export default (store, to ) => {
    if(store.state.meta.items[to.path] != undefined){
        let head = document.head;
        if ('title' in store.state.meta.items[to.path]) {
            document.title = store.state.meta.items[to.path].title;
        }
        if ('keywords' in store.state.meta.items[to.path]) {
            let keywords = head.querySelector('meta[name="keywords"]');
            if (keywords == undefined){
                keywords = document.createElement('meta');
                keywords.setAttribute('name', 'keywords');
                head.appendChild(keywords);
            }
            keywords.setAttribute('content', store.state.meta.items[to.path].keywords);
        }
        if ('description' in store.state.meta.items[to.path]) {
            let description = head.querySelector('meta[name="description"]');
            if (description == undefined){
                description = document.createElement('meta'); 
                description.setAttribute('name', 'description');
                head.appendChild(description);
            }
            description.setAttribute('content',  store.state.meta.items[to.path].description);
        }
    } else {
        document.title = to.meta.title
    }
}


// WEBPACK FOOTER //
// ./src/js/Meta.js